module.exports = __webpack_public_path__ + "static/media/ticket.32e0b92d.mp3";